import React, { useState } from 'react';
import {
  Layout, Menu, Card, Button, Table, Tag, Typography, Space, InputNumber, Alert,
  Switch, Input, Modal, Drawer, Form, Popconfirm, Tooltip, message, Divider, Descriptions
} from 'antd';
import {
  PlusOutlined, EditOutlined, DeleteOutlined, FolderOutlined
} from '@ant-design/icons';

const { Sider, Content } = Layout;
const { Title, Text } = Typography;

// ══════════════════════════════════════════════
//  Mock 数据
// ══════════════════════════════════════════════
// TODO: 联调时替换为接口数据

const PAYMENT_CHANNELS = [
  { key: 'wechat', name: '微信', subNames: ['H5', '小程序', 'App'] },
  { key: 'alipay', name: '支付宝' },
  { key: 'paypal', name: 'PayPal' },
  { key: 'applepay', name: 'Apple Pay' },
  { key: 'googlepay', name: 'Google Pay' },
  { key: 'stripe', name: 'STRIPE' },
  { key: 'payssion', name: 'Payssion' },
  { key: 'zarinpal', name: 'ZARINPAL' },
  { key: 'airwallex', name: 'AIRWALLEX' },
  { key: 'fuiou', name: '富友支付' },
];

const MOCK_ALL_ENTERPRISES = [
  { id: 'ENT_V01', name: 'test-深圳芯视界科技有限公司', type: 'cooperation' },
  { id: 'JGSf0Nd7', name: 'test-东莞康林物联网有限公司', type: 'sub' },
  { id: 'ENT_BJ01', name: 'test-北京智联科技有限公司', type: 'cooperation' },
  { id: 'ENT_HZ02', name: 'test-杭州云睿电子有限公司', type: 'cooperation' },
  { id: 'ENT_SZ03', name: 'test-深圳蓝芯分销商', type: 'sub' },
];

const INIT_RULES = [
  { key: 'default', name: '默认规则', isDefault: true, deductBasePrice: true, enableDiscount: true, discountRate: 100,
    paymentFees: { wechat: 2.5, alipay: 1.8 },
    paymentFixedFeeCny: { wechat: 0.30, alipay: 0.50 },
    paymentFixedFeeUsd: { wechat: 0.05 },
    enterpriseIds: ['ENT_V01', 'JGSf0Nd7', 'ENT_BJ01', 'ENT_HZ02', 'ENT_SZ03'],
  },
  { key: 'rule1', name: '高利润规则', isDefault: false, deductBasePrice: false, enableDiscount: false, discountRate: 100,
    paymentFees: {},
    paymentFixedFeeCny: {},
    paymentFixedFeeUsd: {},
    enterpriseIds: [],
  },
  { key: 'rule2', name: '低利润规则', isDefault: false, deductBasePrice: true, enableDiscount: true, discountRate: 60,
    paymentFees: { wechat: 2.5 },
    paymentFixedFeeCny: { wechat: 0.30 },
    paymentFixedFeeUsd: {},
    enterpriseIds: [],
  },
];

// ══════════════════════════════════════════════
//  支付手续费编辑 Modal
// ══════════════════════════════════════════════
const FeeModal = ({ visible, onCancel, fees, fixedFeeCny, fixedFeeUsd, onSave }) => {
  const [local, setLocal] = useState({});
  const [localCny, setLocalCny] = useState({});
  const [localUsd, setLocalUsd] = useState({});
  const handleOpen = () => {
    setLocal({ ...fees });
    setLocalCny({ ...fixedFeeCny });
    setLocalUsd({ ...fixedFeeUsd });
  };
  return (
    <Modal title="支付通道手续费" open={visible} onCancel={onCancel} width={800}
      onOk={() => { onSave(local, localCny, localUsd); onCancel(); }}
      afterOpenChange={(open) => open && handleOpen()}
      okText="确认" cancelText="取消" destroyOnClose
    >
      <Table dataSource={PAYMENT_CHANNELS} rowKey="key" size="small" pagination={false}
        columns={[
          { title: '支付通道', dataIndex: 'name', width: 140, render: (n, r) => (
            <span>{n}{r.subNames && <span style={{ marginLeft: 4 }}>{r.subNames.map(s => <Tag key={s} style={{ fontSize: 11 }}>{s}</Tag>)}</span>}</span>
          )},
          { title: '手续费比例', key: 'fee', width: 160, render: (_, r) => (
            <InputNumber min={0} max={100} precision={2} value={local[r.key]} onChange={v => setLocal(p => ({ ...p, [r.key]: v }))} placeholder="0.00" addonAfter="%" style={{ width: 130 }} />
          )},
          { title: '额外扣除CNY', key: 'cny', width: 160, render: (_, r) => (
            <InputNumber min={0} precision={2} value={localCny[r.key]} onChange={v => setLocalCny(p => ({ ...p, [r.key]: v }))} placeholder="0.00" style={{ width: 130 }} />
          )},
          { title: '额外扣除USD', key: 'usd', width: 160, render: (_, r) => (
            <InputNumber min={0} precision={2} value={localUsd[r.key]} onChange={v => setLocalUsd(p => ({ ...p, [r.key]: v }))} placeholder="0.00" style={{ width: 130 }} />
          )},
        ]}
      />
    </Modal>
  );
};

// ══════════════════════════════════════════════
//  添加企业 Modal
// ══════════════════════════════════════════════
const AddEnterpriseModal = ({ visible, onCancel, rule, allEnterprises, rules, onAdd }) => {
  const [selected, setSelected] = useState([]);
  const usedIds = rules.flatMap(r => r.key !== rule.key ? r.enterpriseIds : []);
  const available = allEnterprises.filter(e => !usedIds.includes(e.id));
  const handleOpen = () => setSelected([]);
  return (
    <Modal title="添加企业" open={visible} onCancel={onCancel} width={550}
      onOk={() => { onAdd(selected); onCancel(); }}
      afterOpenChange={(open) => open && handleOpen()}
      okText="确认" cancelText="取消" destroyOnClose
    >
      <Table dataSource={available} rowKey="id" size="small" pagination={false}
        rowSelection={{ selectedRowKeys: selected, onChange: (keys) => setSelected(keys) }}
        columns={[
          { title: '企业名称', dataIndex: 'name', render: (n, r) => <div><div style={{ fontWeight: 500 }}>{n}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.id}</Text></div> },
          { title: '企业类型', dataIndex: 'type', width: 100, render: v => <Tag color={v === 'cooperation' ? 'blue' : 'green'} style={{ border: 'none' }}>{v === 'cooperation' ? '合作企业' : '下级企业'}</Tag> },
        ]}
        locale={{ emptyText: '暂无可添加的企业' }}
      />
    </Modal>
  );
};

// ══════════════════════════════════════════════
//  主页面
// ══════════════════════════════════════════════
const BusinessConfig = () => {
  const [rules, setRules] = useState(INIT_RULES);
  const [selectedKey, setSelectedKey] = useState('default');
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [feeModalVisible, setFeeModalVisible] = useState(false);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [addEntModalVisible, setAddEntModalVisible] = useState(false);
  const [, setEditingRuleName] = useState(null);
  const [, setEditNameValue] = useState('');
  const [newRuleForm] = Form.useForm();

  const selectedRule = rules.find(r => r.key === selectedKey) || rules[0];

  // 选中规则
  const handleSelect = (key) => setSelectedKey(key);

  // 编辑规则名称
  const handleStartEditName = () => {
    setEditingRuleName(selectedKey);
    setEditNameValue(selectedRule.name);
  };

  // 修改规则字段
  const updateRule = (field, value) => {
    setRules(prev => prev.map(r => r.key === selectedKey ? { ...r, [field]: value } : r));
  };

  // 企业
  const removeEnterprise = (entId) => {
    updateRule('enterpriseIds', selectedRule.enterpriseIds.filter(id => id !== entId));
  };
  const addEnterprises = (ids) => {
    updateRule('enterpriseIds', [...new Set([...selectedRule.enterpriseIds, ...ids])]);
  };

  // 删除规则
  const handleDeleteRule = (key) => {
    const rule = rules.find(r => r.key === key);
    if (rule.enterpriseIds.length > 0) {
      message.warning('该规则下有关联企业，请先移除企业');
      return;
    }
    if (rule.isDefault) { message.warning('默认规则不可删除'); return; }
    setRules(prev => prev.filter(r => r.key !== key));
    if (selectedKey === key) setSelectedKey('default');
    message.success('规则已删除');
  };

  // 新建规则
  const handleCreateRule = () => {
    newRuleForm.validateFields().then(v => {
      const newRule = {
        key: `rule${Date.now()}`, name: v.name, isDefault: false,
        deductBasePrice: v.deductBasePrice ?? false,
        enableDiscount: v.enableDiscount ?? false,
        discountRate: v.discountRate ?? 100,
        customServices: [], paymentFees: {}, paymentFixedFeeCny: {}, paymentFixedFeeUsd: {}, enterpriseIds: [],
      };
      setRules(prev => [...prev, newRule]);
      setSelectedKey(newRule.key);
      setDrawerVisible(false);
      newRuleForm.resetFields();
      message.success('规则已创建');
    }).catch(() => {});
  };

  // 编辑弹窗本地状态
  const [editLocal, setEditLocal] = useState({});

  const openEditModal = () => {
    setEditLocal({
      name: selectedRule.name,
      deductBasePrice: selectedRule.deductBasePrice,
      enableDiscount: selectedRule.enableDiscount,
      discountRate: selectedRule.discountRate,
      paymentFees: { ...selectedRule.paymentFees },
      paymentFixedFeeCny: { ...(selectedRule.paymentFixedFeeCny || {}) },
      paymentFixedFeeUsd: { ...(selectedRule.paymentFixedFeeUsd || {}) },
    });
    setEditModalVisible(true);
  };

  const handleEditSave = () => {
    setRules(prev => prev.map(r => r.key === selectedKey ? {
      ...r,
      name: editLocal.name,
      deductBasePrice: editLocal.deductBasePrice,
      enableDiscount: editLocal.enableDiscount,
      discountRate: editLocal.discountRate,
      paymentFees: editLocal.paymentFees,
      paymentFixedFeeCny: editLocal.paymentFixedFeeCny,
      paymentFixedFeeUsd: editLocal.paymentFixedFeeUsd,
    } : r));
    setEditModalVisible(false);
    message.success('规则已保存');
  };

  // ══════════════════════════ 文本展示 ══════════════════════════
  const getBasePriceText = () => {
    if (!selectedRule.deductBasePrice) return '不扣除';
    if (!selectedRule.enableDiscount) return '扣除，不打折';
    return `扣除，打折${selectedRule.discountRate}%`;
  };

  const getFeeText = () => {
    const fees = selectedRule.paymentFees;
    const cny = selectedRule.paymentFixedFeeCny || {};
    const usd = selectedRule.paymentFixedFeeUsd || {};
    const allKeys = new Set([...Object.keys(fees), ...Object.keys(cny), ...Object.keys(usd)]);
    const configured = Array.from(allKeys).filter(k => {
      const hasFee = fees[k] !== undefined && fees[k] !== null;
      const hasCny = cny[k] !== undefined && cny[k] !== null;
      const hasUsd = usd[k] !== undefined && usd[k] !== null;
      return hasFee || hasCny || hasUsd;
    });
    if (configured.length === 0) return <Text type="secondary">未配置</Text>;
    if (configured.length <= 2) return <Text>{configured.map(k => {
      const name = PAYMENT_CHANNELS.find(c => c.key === k)?.name || k;
      const parts = [];
      if (fees[k] !== undefined && fees[k] !== null) parts.push(`${fees[k]}%`);
      const fixedParts = [];
      if (usd[k] !== undefined && usd[k] !== null) fixedParts.push(`${usd[k]}USD`);
      if (cny[k] !== undefined && cny[k] !== null) fixedParts.push(`${cny[k]}CNY`);
      const feeStr = parts.join('');
      const fixedStr = fixedParts.length > 0 ? ` + ${fixedParts.join('/')}` : '';
      return `${name}: ${feeStr}${fixedStr}`;
    }).join('，')}</Text>;
    return <Text>{configured.length}个通道已配置</Text>;
  };

  const enterpriseColumns = [
    { title: '企业信息', key: 'ent', render: (_, id) => {
      const e = MOCK_ALL_ENTERPRISES.find(en => en.id === id);
      return e ? <div><div style={{ fontWeight: 500 }}>{e.name}</div><Text type="secondary" style={{ fontSize: 12 }}>{e.id}</Text></div> : <Text type="secondary">—</Text>;
    }},
    { title: '企业类型', key: 'type', width: 100, render: (_, id) => {
      const e = MOCK_ALL_ENTERPRISES.find(en => en.id === id);
      return e ? <Tag color={e.type === 'cooperation' ? 'blue' : 'green'} style={{ border: 'none' }}>{e.type === 'cooperation' ? '合作企业' : '下级企业'}</Tag> : null;
    }},
    { title: '操作', key: 'action', width: 80, render: (_, id) => (
      <Popconfirm title="移出后将回到默认规则" onConfirm={() => removeEnterprise(id)} okText="确定" cancelText="取消">
        <Button type="link" size="small" danger>移除</Button>
      </Popconfirm>
    )},
  ];

  return (
    <div style={{ padding: 0 }}>
      <Layout style={{ minHeight: '100vh', background: '#fff', padding: '24px' }}>
        {/* ════════ 左侧：商务规则 ════════ */}
        <Sider width={280} theme="light" style={{ borderRight: '1px solid #f0f0f0', marginRight: 24 }}>
          <div style={{ padding: '0 12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Title level={4} style={{ margin: 0 }}>商务规则</Title>
            <Button type="primary" size="small" icon={<PlusOutlined />} onClick={() => { newRuleForm.resetFields(); setDrawerVisible(true); }}>添加</Button>
          </div>
          <Menu mode="inline" selectedKeys={[selectedKey]} onClick={({ key }) => handleSelect(key)} style={{ borderRight: 'none' }}>
            {rules.map(r => (
              <Menu.Item key={r.key} icon={<FolderOutlined />} style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ flex: 1 }}>{r.name}{r.isDefault && <Tag color="orange" style={{ marginLeft: 4, fontSize: 11, border: 'none' }}>默认</Tag>}</span>
                <span onClick={e => e.stopPropagation()} style={{ marginLeft: 8 }}>
                  <EditOutlined style={{ fontSize: 12, marginRight: 10, color: '#1890ff' }} onClick={() => { handleSelect(r.key); handleStartEditName(); }} />
                  {r.enterpriseIds.length > 0 ? (
                    <Tooltip title="该规则下有关联企业，请先移除企业"><DeleteOutlined style={{ fontSize: 12, color: '#d9d9d9', cursor: 'not-allowed' }} /></Tooltip>
                  ) : r.isDefault ? (
                    <Tooltip title="默认规则不可删除"><DeleteOutlined style={{ fontSize: 12, color: '#d9d9d9', cursor: 'not-allowed' }} /></Tooltip>
                  ) : (
                    <Popconfirm title={`确定删除规则「${r.name}」？`} onConfirm={() => handleDeleteRule(r.key)} okText="确定" cancelText="取消">
                      <DeleteOutlined style={{ fontSize: 12, color: '#ff4d4f' }} />
                    </Popconfirm>
                  )}
                </span>
              </Menu.Item>
            ))}
          </Menu>
        </Sider>

        {/* ════════ 右侧：详情 + 企业 ════════ */}
        <Content>
          <Alert
            type="info" showIcon
            style={{ marginBottom: 16, borderRadius: 6, padding: '8px 12px' }}
            message="订单收益优先扣除套餐服务底价（若设折扣则按底价×折扣扣减），再扣除支付通道手续费，剩余金额按分润比例分配。修改仅对未来账单生效，不影响已出账账单。"
          />
          {/* 规则详情 */}
          <Card
            title={<Text strong style={{ fontSize: 16 }}>{selectedRule.name}</Text>}
            extra={<Button type="primary" size="small" icon={<EditOutlined />} onClick={openEditModal}>修改</Button>}
            bordered={false} style={{ marginBottom: 16, borderRadius: 8 }}
          >
            <Descriptions column={1} size="small" colon={false} labelStyle={{ color: '#666', width: 140 }}>
              <Descriptions.Item label="扣除套餐服务底价">{getBasePriceText()}</Descriptions.Item>
              <Descriptions.Item label="支付通道费率">{getFeeText()}</Descriptions.Item>
            </Descriptions>
          </Card>

          {/* 关联企业 */}
          <Card title="关联企业" bordered={false} style={{ borderRadius: 8 }}
            extra={<Button type="primary" size="small" icon={<PlusOutlined />} onClick={() => setAddEntModalVisible(true)}>添加企业</Button>}
          >
            <Table dataSource={selectedRule.enterpriseIds} rowKey={id => id} columns={enterpriseColumns} size="small"
              pagination={{ showSizeChanger: true, showTotal: t => `共 ${t} 条记录` }}
              locale={{ emptyText: '暂无关联企业' }}
            />
          </Card>
        </Content>
      </Layout>

      {/* ════════ 新建规则 Drawer ════════ */}
      <Drawer title="新建规则" open={drawerVisible} onClose={() => setDrawerVisible(false)} width={640} destroyOnClose
        footer={<div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}><Button onClick={() => setDrawerVisible(false)}>取消</Button><Button type="primary" onClick={handleCreateRule}>保存</Button></div>}
      >
        <Form form={newRuleForm} layout="vertical">
          <Form.Item name="name" label="商务名称" rules={[{ required: true, message: '请输入商务名称' }]}>
            <Input placeholder="请输入" />
          </Form.Item>
          <Form.Item name="deductBasePrice" label="扣除套餐服务底价" valuePropName="checked" initialValue={false}>
            <Switch />
          </Form.Item>
          <Form.Item noStyle shouldUpdate={(p, c) => p.deductBasePrice !== c.deductBasePrice}>
            {({ getFieldValue }) => getFieldValue('deductBasePrice') ? (
              <>
                <Form.Item name="enableDiscount" label="底价折扣" valuePropName="checked" initialValue={true}>
                  <Switch />
                </Form.Item>
                <Form.Item noStyle shouldUpdate={(p, c) => p.enableDiscount !== c.enableDiscount}>
                  {({ getFieldValue: gv }) => gv('enableDiscount') ? (
                    <Form.Item name="discountRate" label="折扣比例" initialValue={100}>
                      <InputNumber min={1} precision={0} addonAfter="%" style={{ width: 140 }} />
                    </Form.Item>
                  ) : null}
                </Form.Item>
              </>
            ) : null}
          </Form.Item>
        </Form>
        <Text type="secondary" style={{ fontSize: 12 }}>自定义服务分类底价和支付通道手续费可在创建后配置。</Text>
      </Drawer>

      {/* ════════ 编辑规则 Modal ════════ */}
      <Modal title="编辑规则" open={editModalVisible} onCancel={() => setEditModalVisible(false)} width={700}
        onOk={handleEditSave} okText="保存" cancelText="取消" destroyOnClose
      >
        <Form layout="vertical">
          <Form.Item label="规则名称">
            <Input value={editLocal.name} onChange={e => setEditLocal(p => ({ ...p, name: e.target.value }))} />
          </Form.Item>
          <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 32 }}>
            <Space><Text strong>扣除套餐服务底价：</Text>
              <Switch checked={editLocal.deductBasePrice} onChange={v => setEditLocal(p => ({ ...p, deductBasePrice: v }))} />
            </Space>
            {editLocal.deductBasePrice && (
              <Space>
                <Text strong>底价折扣：</Text>
                <Switch checked={editLocal.enableDiscount} onChange={v => setEditLocal(p => ({ ...p, enableDiscount: v }))} />
                {editLocal.enableDiscount && (
                  <InputNumber min={1} precision={0} value={editLocal.discountRate}
                    onChange={v => v > 0 && setEditLocal(p => ({ ...p, discountRate: v }))} addonAfter="%" style={{ width: 100 }} />
                )}
              </Space>
            )}
          </div>

          <Divider orientation="left" plain style={{ fontSize: 13 }}>支付通道费率</Divider>
          <Table dataSource={PAYMENT_CHANNELS} rowKey="key" size="small" pagination={false}
            columns={[
              { title: '支付通道', dataIndex: 'name', width: 140, render: (n, r) => (
                <span>{n}{r.subNames && <span style={{ marginLeft: 4 }}>{r.subNames.map(s => <Tag key={s} style={{ fontSize: 11 }}>{s}</Tag>)}</span>}</span>
              )},
              { title: '手续费比例', key: 'fee', width: 160, render: (_, r) => (
                <InputNumber min={0} max={100} precision={2}
                  value={editLocal.paymentFees?.[r.key]}
                  onChange={v => setEditLocal(p => ({ ...p, paymentFees: { ...p.paymentFees, [r.key]: v } }))}
                  placeholder="0.00" addonAfter="%" style={{ width: 130 }} />
              )},
              { title: '额外扣除CNY', key: 'cny', width: 160, render: (_, r) => (
                <InputNumber min={0} precision={2}
                  value={editLocal.paymentFixedFeeCny?.[r.key]}
                  onChange={v => setEditLocal(p => ({ ...p, paymentFixedFeeCny: { ...p.paymentFixedFeeCny, [r.key]: v } }))}
                  placeholder="0.00" style={{ width: 130 }} />
              )},
              { title: '额外扣除USD', key: 'usd', width: 160, render: (_, r) => (
                <InputNumber min={0} precision={2}
                  value={editLocal.paymentFixedFeeUsd?.[r.key]}
                  onChange={v => setEditLocal(p => ({ ...p, paymentFixedFeeUsd: { ...p.paymentFixedFeeUsd, [r.key]: v } }))}
                  placeholder="0.00" style={{ width: 130 }} />
              )},
            ]}
          />
        </Form>
      </Modal>

      {/* ════════ Modal ════════ */}
      <FeeModal visible={feeModalVisible} onCancel={() => setFeeModalVisible(false)}
        fees={selectedRule.paymentFees}
        fixedFeeCny={selectedRule.paymentFixedFeeCny || {}}
        fixedFeeUsd={selectedRule.paymentFixedFeeUsd || {}}
        onSave={(fees, cny, usd) => {
          updateRule('paymentFees', fees);
          updateRule('paymentFixedFeeCny', cny);
          updateRule('paymentFixedFeeUsd', usd);
        }}
      />
      <AddEnterpriseModal visible={addEntModalVisible} onCancel={() => setAddEntModalVisible(false)}
        rule={selectedRule} rules={rules} allEnterprises={MOCK_ALL_ENTERPRISES} onAdd={addEnterprises}
      />
    </div>
  );
};

export default BusinessConfig;
